import { Clock, Zap } from "@untitledui/icons";
import { formatTime } from "../utils/tracking.utils";

type RoutePlaybackPositionPopupProps = {
	timestamp: number;
	speed: number;
	distanceKm: number;
};

const OdometerIcon = () => (
	<svg
		className="size-4 shrink-0"
		fill="none"
		height="12"
		viewBox="0 0 12 12"
		width="12"
		xmlns="http://www.w3.org/2000/svg"
	>
		<title>Distância percorrida</title>
		<path
			d="M8.16667 11.0833V9.33333H6.41667V8.16667H8.16667V6.41667H9.33333V8.16667H11.0833V9.33333H9.33333V11.0833H8.16667ZM8.16667 5.25V0H9.33333V5.25H8.16667ZM0 9.33333V0H1.16667V9.33333H0ZM4.08333 2.33333V0H5.25V2.33333H4.08333ZM4.08333 5.83333V3.5H5.25V5.83333H4.08333ZM4.08333 9.33333V7H5.25V9.33333H4.08333Z"
			fill="#424754"
		/>
	</svg>
);

export const RoutePlaybackPositionPopup = ({
	timestamp,
	speed,
	distanceKm,
}: RoutePlaybackPositionPopupProps) => (
	<div
		className="flex w-max items-center gap-3 whitespace-nowrap px-1 py-0.5"
		data-slot="route-playback-position-popup"
	>
		<div className="flex shrink-0 items-center gap-1.5">
			<Clock className="size-4 shrink-0 text-gray-500" />
			<span className="font-semibold text-[#101828] text-sm">
				{formatTime(new Date(timestamp).toISOString())}
			</span>
		</div>

		<span className="h-4 w-px shrink-0 bg-gray-200" />

		<div className="flex shrink-0 items-center gap-1.5">
			<Zap className="size-4 shrink-0 text-gray-500" />
			<span className="font-semibold text-[#101828] text-sm">
				{Math.round(speed)} km/h
			</span>
		</div>

		<span className="h-4 w-px shrink-0 bg-gray-200" />

		<div className="flex shrink-0 items-center gap-1.5">
			<OdometerIcon />
			<span className="font-semibold text-[#101828] text-sm">
				{String(Math.round(distanceKm)).padStart(2, "0")} km rodados
			</span>
		</div>
	</div>
);
